module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-form', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "keyword-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form_data.keyword),
      expression: "form_data.keyword"
    }],
    staticClass: "keyword-search form-control",
    attrs: {
      "list": "search-keyword",
      "type": "text",
      "placeholder": "Search for a movie"
    },
    domProps: {
      "value": (_vm.form_data.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form_data, "keyword", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.form_data.keyword && _vm.form_data.keyword.length > 2) ? _c('datalist', {
    attrs: {
      "id": "search-keyword"
    }
  }, _vm._l((_vm.predictiveText), function(text) {
    return _c('option', {
      domProps: {
        "value": text
      }
    }, [_vm._v(_vm._s(text))])
  })) : _vm._e(), _vm._v(" "), (!_vm.$breakpoints.xs) ? _c('label', {
    staticClass: "filter-label"
  }, [_vm._v("Filter by:")]) : _vm._e(), _vm._v(" "), (_vm.$breakpoints.xs) ? _c('div', {
    staticClass: "filter-mobile-btns"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('sk-button', {
    staticClass: "filter-mobile",
    nativeOn: {
      "click": function($event) {
        _vm.cinemaActive = true
      }
    }
  }, [_vm._v("Cinema")])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('sk-layout', [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('sk-button', {
    staticClass: "filter-mobile",
    nativeOn: {
      "click": function($event) {
        _vm.filterActive = true
      }
    }
  }, [_vm._v("Filter")])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('sk-button', {
    staticClass: "reset-label",
    attrs: {
      "link": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.$breakpoints.xs) ? [_c('sk-google-places-input', {
    ref: "location_input",
    staticClass: "location-search",
    attrs: {
      "placeholder": "Seach location",
      "geolocation": "",
      "autocomplete": "",
      "pinOnly": ""
    },
    on: {
      "place-selected": _vm.placeSelected
    },
    model: {
      value: (_vm.form_data.place_query),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "place_query", $$v)
      },
      expression: "form_data.place_query"
    }
  }), _vm._v(" "), _c('sk-multi-select-regions', {
    staticClass: "filter-select form-group",
    attrs: {
      "val": _vm.selected_cinema,
      "items": _vm.cinemasByRegion
    },
    model: {
      value: (_vm.selected_cinema),
      callback: function($$v) {
        _vm.selected_cinema = $$v
      },
      expression: "selected_cinema"
    }
  }), _vm._v(" "), _c('sk-multi-select-types', {
    staticClass: "filter-select form-group",
    attrs: {
      "val": _vm.form_data.cinema_types,
      "items": _vm.cinemaTypes,
      "multiple": true
    },
    model: {
      value: (_vm.form_data.cinema_types),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "cinema_types", $$v)
      },
      expression: "form_data.cinema_types"
    }
  }), _vm._v(" "), _c('sk-multi-select-genres', {
    staticClass: "filter-select form-group",
    attrs: {
      "val": _vm.form_data.genres,
      "items": _vm.movieGenres,
      "multiple": true
    },
    model: {
      value: (_vm.form_data.genres),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "genres", $$v)
      },
      expression: "form_data.genres"
    }
  }), _vm._v(" "), _c('sk-multi-select-times', {
    staticClass: "filter-select form-group",
    attrs: {
      "val": _vm.selected_time_range,
      "items": _vm.timeRanges
    },
    model: {
      value: (_vm.selected_time_range),
      callback: function($$v) {
        _vm.selected_time_range = $$v
      },
      expression: "selected_time_range"
    }
  })] : _vm._e(), _vm._v(" "), _c('sk-button', {
    staticClass: "hidden-xs reset-label",
    attrs: {
      "link": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_vm._v("Reset")]), _vm._v(" "), (_vm.$breakpoints.xs) ? _c('sk-dialog', {
    attrs: {
      "fullscreen": "",
      "transition": "sk-dialog-bottom-transition"
    },
    model: {
      value: (_vm.cinemaActive),
      callback: function($$v) {
        _vm.cinemaActive = $$v
      },
      expression: "cinemaActive"
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "dialog__header"
  }, [_c('div', {
    staticClass: "dialog__header-title"
  }, [_vm._v("Filter your movies")]), _vm._v(" "), _c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cinemaActive = false
      }
    }
  })], 1), _vm._v(" "), _c('sk-google-places-input', {
    ref: "location_input",
    staticClass: "location-search",
    attrs: {
      "placeholder": "Seach location",
      "geolocation": "",
      "autocomplete": "",
      "pinOnly": ""
    },
    on: {
      "place-selected": _vm.placeSelected
    },
    model: {
      value: (_vm.form_data.place_query),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "place_query", $$v)
      },
      expression: "form_data.place_query"
    }
  }), _vm._v(" "), _c('sk-multi-select-regions', {
    staticClass: "cinema-select form-group",
    attrs: {
      "val": _vm.selected_cinema,
      "items": _vm.cinemasByRegion
    },
    model: {
      value: (_vm.selected_cinema),
      callback: function($$v) {
        _vm.selected_cinema = $$v
      },
      expression: "selected_cinema"
    }
  }), _vm._v(" "), (_vm.searchResultCount != null) ? _c('div', [(_vm.searchResultCount > 0) ? [_vm._v("\n                        Results for selection: " + _vm._s(_vm.searchResultCount)), _c('br'), _c('br')] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cinemaActive = false
      }
    }
  }, [_vm._v("Show Results")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$breakpoints.xs) ? _c('sk-dialog', {
    attrs: {
      "fullscreen": "",
      "transition": "sk-dialog-bottom-transition"
    },
    model: {
      value: (_vm.filterActive),
      callback: function($$v) {
        _vm.filterActive = $$v
      },
      expression: "filterActive"
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "dialog__header"
  }, [_c('div', {
    staticClass: "dialog__header-title"
  }, [_vm._v("Filter your movies")]), _vm._v(" "), _c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.filterActive = false
      }
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v("\n                   Cinema Types\n                ")]), _vm._v(" "), _c('sk-multi-select-types', {
    staticClass: "filter-select form-group",
    attrs: {
      "val": _vm.form_data.cinema_types,
      "items": _vm.cinemaTypes,
      "multiple": true
    },
    model: {
      value: (_vm.form_data.cinema_types),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "cinema_types", $$v)
      },
      expression: "form_data.cinema_types"
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n                   Genres\n                ")]), _vm._v(" "), _c('sk-multi-select-genres', {
    staticClass: "filter-select form-group",
    attrs: {
      "val": _vm.form_data.genres,
      "items": _vm.movieGenres,
      "multiple": true
    },
    model: {
      value: (_vm.form_data.genres),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "genres", $$v)
      },
      expression: "form_data.genres"
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n                   Show Times\n                ")]), _vm._v(" "), _c('sk-multi-select-times', {
    staticClass: "filter-select form-group",
    attrs: {
      "val": _vm.selected_time_range,
      "items": _vm.timeRanges
    },
    model: {
      value: (_vm.selected_time_range),
      callback: function($$v) {
        _vm.selected_time_range = $$v
      },
      expression: "selected_time_range"
    }
  }), _vm._v(" "), (_vm.searchResultCount != null) ? _c('div', [(_vm.searchResultCount > 0) ? [_vm._v("\n                        Results for selection: " + _vm._s(_vm.searchResultCount)), _c('br'), _c('br')] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.filterActive = false
      }
    }
  }, [_vm._v("Show Results")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0edc81c0","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/generic/search-filter/search-filter.vue
// module id = 899
// module chunks = 0